<!-- Add to cart modal popup start-->
@for (product of products; track product) {
  <div class="modal fade bd-example-modal-lg theme-modal cart-modal addTocartModal" [id]="'addtocart'+product.id"
    tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body modal1">
          <div class="container-fluid p-0">
            <div class="row">
              <div class="col-12">
                <div class="modal-bg addtocart">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <div class="media">
                    <a [routerLink]="['/home/left-sidebar/product', product.id]">
                      @if (product.image) {
                        <img class="img-fluid pro-img" [src]="product.image" alt=""
                          imageLoader thumbnailSize="L">
                      }
                    </a>
                    <div class="media-body align-self-center text-center">
                      <a [routerLink]="['/home/left-sidebar/product', product.id]">
                        <h6>
                          <i class="fa fa-check"></i>Item
                          <span>{{product.name}}</span>
                          <span> successfully added to your Cart</span>
                        </h6>
                      </a>
                      <div class="buttons">
                        <a [routerLink]="['/home/cart']" class="btn btn-solid">Your
                        cart</a>
                        <a [routerLink]="['/home/checkout']" class="checkout btn btn-solid">Check
                        out</a>
                        <a [routerLink]="['/home/left-sidebar/collection/all']"
                        class="continue btn btn-solid">continue shopping</a>
                      </div>
                      <div class="upsell_payment">
                        <img src="assets/images/payment_cart.png" class="img-fluid" alt="">
                      </div>
                    </div>
                  </div>
                  <div class="product-section">
                    <div class="col-12 product-upsell text-center">
                      <h4>Customers who bought this item also.</h4>
                    </div>
                    <div class="row" id="upsell_product">
                      @for (relatedProduct of relatedProducts(product) | slice:0:4; track relatedProduct) {
                        <div class="product-box col-sm-3 col-6"
                          >
                          <div class="img-wrapper">
                            <div class="front">
                              <a [routerLink]="['/home/left-sidebar/product', relatedProduct.id]">
                                <img [src]="relatedProduct.pictures[0]" class="img-fluid mb-1"
                                  alt="">
                                </a>
                              </div>
                              <div class="product-detail">
                                <h6 class="mt-0"><a
                                  [routerLink]="['/home/left-sidebar/product', relatedProduct.id]"><span>{{relatedProduct.name}}</span></a>
                                </h6>
                                <h4><span>{{relatedProduct.price | currency:productsService?.currency:'symbol'}}</span>
                              </h4>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
<!-- Add to cart modal popup end-->